module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Barcode-read-36b83907806b40508c9e57e062798bdd.svg";